import {
  createSlice,
  PayloadAction
} from "@reduxjs/toolkit"

import { UserDetail } from "#types/api";

interface AuthState {
  is_logged: boolean;
  user?: UserDetail;
  ready?: boolean;
}

const initialState: AuthState = {
  is_logged: false,
  user: undefined,
  ready: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loadUser: (state, action: PayloadAction<Partial<AuthState>>) => ({
      ...state,
      ...action.payload,
    }),
    setReady: (state, action: PayloadAction<boolean>) => ({
      ...state,
      ready: action.payload,
    }),
    clearData: (state) => ({ ...state, ...initialState, ready: true }),
  },
});

export default authSlice.reducer;

export const authActions = authSlice.actions;
